module.exports = __webpack_public_path__ + "static/img/selected.08d1f9d2.svg";